import React, { useEffect, useState } from 'react';
import { useQueryParam } from 'gatsby-query-params';
import { API } from 'aws-amplify';
import Layout from '../components/layout';
import PageTopper, { LinkD } from '../components/pagetopper';
import ComplexAuto from '../components/complexauto';
import { useChanList, ChannelChoice, useChanDict } from '../components/chanutil';

import { useSnackbar } from 'notistack';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';

import { reportsAutoList } from '../graphql/queries.js';

const showDebug = (rawjson) => {
    return (<pre>Response:<br />{JSON.stringify(rawjson, null, 2)}</pre>)
};

const RptAutoPage = () => {
    const { enqueueSnackbar } = useSnackbar();
    const vdebug = useQueryParam('debug', '');

    const [currchan, setCurrChann] = useState('all');

    const [hdata, setHdata] = useState({"data":{"listReports":{"items":[], "loading": "true"}}});
    const [adata, setAdata] = useState([]);

    const [pgserial, setPgserial] = useState(0);

    const chlist = useChanList(1, 0, vdebug);
    const chdict = useChanDict(vdebug);

    // get list
    useEffect(() => {
      console.log("get list useeffect");
      let wkpend = true;
      const fetchData = async () => {
          try {
              if (vdebug !== null) {
                  console.log(pgserial);
              }
              const result = await API.graphql({query: reportsAutoList});
              if (vdebug !== null) {
                  console.log("gql success");
                  console.log(result);
              }
              if (wkpend) {
                  wkpend = false;
                  setHdata(result);
                  enqueueSnackbar(`fetched ${result.data.listReports.items.length} total reports`,
                    {variant: 'info', anchorOrigin: {vertical: 'bottom', horizontal: 'right'}} );
              }
          } catch (result) {
              if (vdebug !== null) {
                  console.log("gql error", result);
              }
              enqueueSnackbar(`error retrieving reports`, {variant: 'error'});
          }
      };

      fetchData();
    }, [pgserial, vdebug, enqueueSnackbar]);

    // annotated data
    useEffect(() => {
        console.log("annotated data useeffect");
        let wkrpts = hdata.data.listReports.items.reduce(function(result,item) {
            let reqind = '';
            let outdate = item.lastrptdate;
            let reqdate = new Date(item.lastreqdate);
            let wkdate = new Date(item.lastrptdate);
            if (item.lastreqdate && reqdate > wkdate) {
                outdate = item.lastreqdate;
                reqind = 'request';
            }
            let chid = item.cidfchg.replace('-_CPULL', '');

            if (currchan === "all" || currchan === chdict[chid]) {
                if (reqind === '') {
                    result.push({...item,
                        chname: chdict[chid],
                        lastactdate: outdate,
                    });
                } else {
                    result.push({...item,
                        chname: chdict[chid],
                        lastactdate: outdate,
                        reqind: reqind
                    });
                }
            }
            return result;
          },[]);

        wkrpts.sort(function(a, b) {
            let x = new Date(a.lastactdate);
            let y = new Date(b.lastactdate);
            return x === y ? 0: x < y ? 1 : -1;
        });
        setAdata(wkrpts);
        if (vdebug !== null) {
            console.log("annotate complete");
        }

    }, [hdata, chdict, currchan, vdebug]);

return (
  <Layout>
  <PageTopper pname="Report Automation" vdebug={vdebug}
    helpPage="/help/rptauto"
    />

  <Paper elevation={5} style={{clear: 'both'}}>
      <Box display='flex' mx={5} justifyContent='space-between'>
      <ChannelChoice allowall='true' currchan={currchan} setchan={setCurrChann} channels={chlist}/>

      <span>
      {adata.length} displayed reports
      <IconButton aria-label="refresh" onClick={() => {setPgserial(pgserial+1)} }>
      <RefreshIcon fontSize="inherit" /></IconButton>
      </span>
      </Box>

<TableContainer style={{ maxHeight: 440 }}><Table size="small" stickyHeader>
   <TableHead><ChgSummHeader /></TableHead>
    <TableBody>

 { adata && adata.map(item => (
     ChgSummListItem(item, vdebug)
  )) }

</TableBody></Table></TableContainer>
      { (hdata.data.listReports.loading === "true") &&
        <center>Loading...</center>
      }

</Paper>
    {vdebug && showDebug(adata)}
    {vdebug && showDebug(hdata)}
  </Layout>
)}

const StyledTableCell = withStyles((theme) => ({
  head: {
      padding: '2px',
      '&:first-of-type': {
          padding: '5px',
      },
    backgroundColor: '#444464',
    color: theme.palette.common.white,
  },
  body: {
    padding: '2px',
    '&:first-of-type': {
        padding: '5px',
    },
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

var prettyTime = new Intl.DateTimeFormat("en-US", {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
});


const ChgSummHeader = () => {
    return(
        <TableRow>
        <Tooltip title="Status for incomplete or errors">
        <StyledTableCell>Status</StyledTableCell>
        </Tooltip>
        <Tooltip title="Click on report name for activity log">
          <StyledTableCell>Channel & Name</StyledTableCell>
        </Tooltip>

        <Tooltip title="Last request or download, requests without downloads are marked">
        <StyledTableCell>Last activity</StyledTableCell>
        </Tooltip>

        <Tooltip title="Report import process">
        <StyledTableCell>Import</StyledTableCell>
        </Tooltip>

        </TableRow>
        )
}

const ChgSummListItem = (item, vdebug) => {
    return(
        <StyledTableRow key={item.cidreport}>
            <StyledTableCell>{item.reqind}</StyledTableCell>
          <StyledTableCell><LinkD vdebug={vdebug}  to={`/rptdetail?crpt=${item.cidreport}&chan=${item.chname}`}><small>{item.chname}</small> {item.nname}</LinkD></StyledTableCell>
          <StyledTableCell>{ prettyTime.format(new Date(item.lastactdate)) } </StyledTableCell>
          <StyledTableCell>{ComplexAuto(item, vdebug)}</StyledTableCell>

        </StyledTableRow>
        )
}

export default RptAutoPage

